import {
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  styled,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps
} from '@mui/material';
import { FC } from 'react';

type Props = MuiSwitchProps &
  Pick<FormControlLabelProps, 'labelPlacement'> & {
    label?: string;
    fullWidth?: boolean;
    error?: boolean;
    helperText?: string;
    boldLabel?: boolean;
    smallLabel?: boolean;
  };
export type SwitchProps = Props;

const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
  height: 24,
  width: 40,
  padding: 0,
  margin: 12,

  '& .MuiSwitch-switchBase': {
    backgroundColor: 'none',
    padding: 0,
    margin: 2,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.heaven.main,
        opacity: 1
      }
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.5
    }
  },
  '& .MuiSwitch-thumb': {
    height: 20,
    backgroundColor: 'white',
    boxShadow: 'unset'
  },
  '& .MuiSwitch-track': {
    height: 24,
    borderRadius: 24 / 2,
    backgroundColor: theme.palette.grey[100],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  },
  '&:hover .MuiSwitch-track, & .Mui-focusVisible + .MuiSwitch-track': {
    backgroundColor: `${theme.palette.heaven['light']} !important`
  }
}));

const StyledFormControlLabel = styled(FormControlLabel)<{ smallLabel?: boolean }>(
  ({ theme, smallLabel }) => ({
    marginLeft: 0,
    '& .MuiFormControlLabel-label': {
      color: theme.palette.grey[500],
      fontSize: smallLabel ? '14px' : '16px',
      lineHeight: smallLabel ? '20px' : '24px',
      transition: theme.transitions.create(['color'], {
        duration: 300
      })
    },
    '&:has(.MuiSwitch-switchBase.Mui-checked) .MuiFormControlLabel-label': {
      color: theme.palette.primary.main
    }
  })
);

export const Switch: FC<Props> = ({
  label,
  labelPlacement,
  fullWidth,
  helperText,
  boldLabel,
  smallLabel,
  ...switchProps
}) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <StyledFormControlLabel
        control={<StyledSwitch {...switchProps} />}
        label={label && boldLabel ? <b>{label}</b> : label || ''}
        labelPlacement={labelPlacement || 'end'}
        smallLabel={smallLabel}
        className={`${fullWidth && 'flex justify-between'}`}
      />
      <div className="pt-2 text-xs !text-grey-600">{helperText}</div>
    </FormControl>
  );
};
